/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateDocumentRequest { 
    documentId?: string | null;
    envelopeId?: string | null;
    documentSequence?: number | null;
    documentName?: string | null;
    documentContentId?: string | null;
    documentContentCrc?: string | null;
    documentContentVersion?: number | null;
    signedDocumentId?: string | null;
    signedDocumentCrc?: string | null;
    documentsLogUserId?: string | null;
    isActive?: boolean | null;
    timeStamp?: string | null;
    readonly spolloNullIsValue_DocumentContentId?: boolean;
    readonly spolloNullIsValue_DocumentContentCrc?: boolean;
    readonly spolloNullIsValue_SignedDocumentId?: boolean;
    readonly spolloNullIsValue_SignedDocumentCrc?: boolean;
    readonly spolloNullIsValue_DocumentsLogUserId?: boolean;
}

